import CustomerBar from "./CustomerBar"
export default CustomerBar
